export default "__VITE_ASSET__95443d57__"